__turbopack_context__.v({
  "recaptchaHidden": "recaptcha-module-scss-module__YIEQtq__recaptchaHidden",
  "recaptchaPolicy": "recaptcha-module-scss-module__YIEQtq__recaptchaPolicy",
  "recaptchaWrp": "recaptcha-module-scss-module__YIEQtq__recaptchaWrp",
});
